/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Additional_Instructions_PlaceholderInputs */

const en_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Use formal language. Avoid describing colours as the target audience is visually impaired...`)
};

const fr_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par exemple, utilisez un langage formel. Évitez de décrire les couleurs, car le public cible est malvoyant.`)
};

const de_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Verwenden Sie eine formelle Sprache. Vermeiden Sie Farbbeschreibungen, da die Zielgruppe sehbehindert ist…`)
};

const it_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad esempio, utilizzare un linguaggio formale. Evitare di descrivere i colori, poiché il pubblico di riferimento è ipovedente...`)
};

const ru_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Например, используйте формальный язык. Избегайте описания цветов, поскольку целевая аудитория — слабовидящие...`)
};

const es_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por ejemplo, utilice un lenguaje formal. Evite describir colores, ya que el público objetivo tiene discapacidad visual.`)
};

const zh_cn2_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：使用正式语言。避免描述颜色，因为目标受众是视障人士……`)
};

const ja_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例：丁寧な言葉遣いを心がけてください。対象読者は視覚障害者であるため、色の描写は避けてください。`)
};

const hi_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उदाहरण के लिए, औपचारिक भाषा का प्रयोग करें। रंगों का वर्णन करने से बचें क्योंकि लक्षित दर्शक दृष्टिबाधित हैं...`)
};

const pt_pt2_additional_instructions_placeholder = /** @type {(inputs: Additional_Instructions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por exemplo, use linguagem formal. Evite descrever cores, pois o público-alvo tem deficiência visual.`)
};

/**
* | output |
* | --- |
* | "e.g. Use formal language. Avoid describing colours as the target audience is visually impaired..." |
*
* @param {Additional_Instructions_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const additional_instructions_placeholder = /** @type {((inputs?: Additional_Instructions_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Additional_Instructions_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_additional_instructions_placeholder(inputs)
	if (locale === "de") return de_additional_instructions_placeholder(inputs)
	if (locale === "it") return it_additional_instructions_placeholder(inputs)
	if (locale === "ru") return ru_additional_instructions_placeholder(inputs)
	if (locale === "es") return es_additional_instructions_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_additional_instructions_placeholder(inputs)
	if (locale === "ja") return ja_additional_instructions_placeholder(inputs)
	if (locale === "hi") return hi_additional_instructions_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_additional_instructions_placeholder(inputs)
	return en_additional_instructions_placeholder(inputs)
});